import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

type CustomCircleChartProps = {
  value: number;
  color?: string;
  textColor?: string;
  label?: string;
  height?: number | string;
};

const CustomCircleChart = ({
  value,
  color = '#2CA2C1',
  textColor,
  label,
  height = 250,
}: CustomCircleChartProps) => {
  return (
    <div className="relative w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          {/* Main Background Ring (Full Color) */}
          <Pie
            data={[{ value: 100 }]}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            innerRadius={70}
            outerRadius={100}
            stroke="none"
          >
            <Cell fill={color} />
          </Pie>

          {/* Progress Overlay Ring (Gray) */}
          <Pie
            data={[
              { value: Math.max(0, 100 - value) },
              { value: Math.min(100, value) },
            ]}
            dataKey="value"
            startAngle={90}
            endAngle={450}
            innerRadius={65}
            outerRadius={105}
            stroke="none"
          >
            <Cell fill="white" />
            <Cell fill="transparent" />
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
        <div
          className="text-2xl font-bold"
          style={{ color: textColor || color }}
        >
          {value.toFixed(2)}%
        </div>
        {label && <div className="text-white text-base mt-1">{label}</div>}
      </div>
    </div>
  );
};

export default CustomCircleChart;
